import * as React from "react";
import { useHubXSubscribe, useHubx } from "../../HubX";
import {
  EVENT_HOMEPAGE_CHANGE_FILTER,
  EVENT_HOMEPAGE_OPEN_ALL,
  EVENT_HOME_INSTALLATIONS_ALREADY_LOADED,
  EVENT_HOME_PAGE_PRODUCT_FILTER_RECEIVE,
  EVENT_HOME_PAGE_PRODUCT_FAVORITE_FILTER_RECEIVE,
  EVENT_LANDING_PAGE_FILTER,
  OPEN_EXPAND_DIALOG,
} from "../../Events";
import CustomerModel from "../../core/models/Customer";
import useConstructor from "../../core/hooks/useConstructor";
import {
  ADD_OR_REMOVE_FAVORITE_INSTALLATION,
  FETCH_CUSTOMERS_BY_GROUP,
  FETCH_GROUPS,
  FETCH_USER_FAVORITE_INSTALLATIONS,
  FILTER_ALL_INSTALLATIONS_NEW,
} from "../../Fedx";
import HomeGroupAccordion from "../../components/HomeGroupAccordion";
import {
  Box,
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogTitle,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { isArrayValid } from "../../helpers/utility";
import { Skeleton } from "@material-ui/lab";
import { useSnackbar } from "notistack";
import uniq from "lodash/uniq";
import CustomerGroupModel from "../../core/models/CustomerGroup";
import { includes, orderBy, sortBy } from "lodash";
import { SessionCache } from "../../helpers/cache";
import User from "../../core/models/User";
import { PERMISSION_ACCESS_INFORM_LEVEL } from "../../core/models/Permission";
import useAuth from "../../core/hooks/useAuth";
import { useHistory } from "react-router";
import InstallationGroup from "../../core/models/InstallationGroup";
import { UserFavoriteInstallations } from "../../core/contracts/UserFavoriteInstallations";
import { IInstallation } from "../../core/contracts/IInstallation";
import { INTERNAL } from "../../core/models/GroupTypeEnum";
import AllInstallationsFilterType from "../../core/models/AllInstallationsFilter";
import FavoriteInstallation from "../../core/models/FavoriteInstallation";
import { APP_DEFAULT_FAVORITE_INSTALLATION_ID } from "../../core/constants/appGlobals";

export type HomePageViewType = "card" | "table";
export type CustomerAccordionType = { [id: string]: boolean } | null;

const DEFAULT_NUMBER_OF_GROUP_INSTALLATIONS = 4;
const emptyInstallations = new Array(DEFAULT_NUMBER_OF_GROUP_INSTALLATIONS).fill({});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonSecondary: {
      color: theme.customPalette.text.darkgrey,
      textDecoration: "underline",
    },
  })
);

type HomeProps = {
  appLinks: unknown;
};

function Home({ appLinks }: HomeProps) {
  const [view, setView] = React.useState<HomePageViewType>("card");
  const [customers, setCustomers] = React.useState<CustomerModel[]>([]);
  const [radixGroups, setRadixGroups] = React.useState<InstallationGroup[]>([]);
  const [isLoading, setLoading] = React.useState(false);
  const [idOpen, setIdOpen] = React.useState<number[]>([0]);
  const [groups, setGroups] = React.useState<CustomerGroupModel[]>([]);
  const [allInstallationIdx, setAllInstallationIds] = React.useState<{ installation_id: any }[]>(
    []
  );
  const [installationIdx, setInstallationIds] = React.useState<{ installation_id: any }[]>([]);
  const [modalConfirmOpen, setModalConfirmOpen] = React.useState(false);
  const [favorites, setFavorites] = React.useState<CustomerModel>();
  const [tempFavorites, setTempFavorites] = React.useState<CustomerModel>();
  const [hasSearched, setHasSearched] = React.useState(false)

  const hub = useHubx();
  const toastr = useSnackbar();
  const homeAppLinks: any = appLinks;
  const authProvider = useAuth();
  const history = useHistory();
  const classes = useStyles();

  const StorageCache = new SessionCache();

  useHubXSubscribe(EVENT_HOMEPAGE_OPEN_ALL, () => {
    handleExpandAll();
  });

  useHubXSubscribe(OPEN_EXPAND_DIALOG, () => {
    setModalConfirmOpen(true);
  });

  useConstructor(async () => {
    // Redirect user if is only in WM internal group
    setLoading(true);

    try {
      const StorageCache = new SessionCache();
      const LoggedUser: User | null = StorageCache.get("user");

      const groups: InstallationGroup[] | undefined = LoggedUser?.installationGroup ?? [];
      setRadixGroups(groups);

      const APIResponse: CustomerGroupModel[] = sortBy(
        await hub.request(FETCH_CUSTOMERS_BY_GROUP),
        "customer_name"
      );

      const allIdsToRequest = APIResponse.flatMap((c) => {
        return c.installationIds.map((id) => {
          return { installation_id: id };
        });
      });

      if (isArrayValid(APIResponse[0]?.installationIds)) {
        const ids = APIResponse[0].installationIds.map((id) => {
          return { installation_id: id };
        });

        setAllInstallationIds(allIdsToRequest);
        setInstallationIds(ids);
        setGroups(APIResponse);

        const favoriteUserInstallations: UserFavoriteInstallations = await hub.request(
          FETCH_USER_FAVORITE_INSTALLATIONS
        );

        if (isArrayValid(favoriteUserInstallations?.installationsIds)) {


  
          
          const installationIds = favoriteUserInstallations?.installationsIds.map(id => Number.parseInt(id));

          const favoriteParams = {
            installation_ids: installationIds,
            installation_has_rtu: 1,
            page_size: installationIds.length,
            return_ids: false,
          } as AllInstallationsFilterType
          
          const favoriteInstallations: IInstallation[] = await hub.request(
            FILTER_ALL_INSTALLATIONS_NEW,
            favoriteParams
          );

          const favoritesData = {
            customer_id: "0",
            customer_name: "Favoritos",
            installations: favoriteInstallations
          };

          const possibleProductsFavorites = uniq(
            favoritesData.installations.flatMap((x) =>
              x.product_code)
            );

          hub.notify(EVENT_HOME_PAGE_PRODUCT_FAVORITE_FILTER_RECEIVE, possibleProductsFavorites);

          StorageCache.set("favorites", favoritesData);

          setFavorites(favoritesData);
          setTempFavorites(favoritesData);
        }
        
        const APIInstallationsResponse: CustomerModel[] = await hub.request(FETCH_GROUPS, {
          idsToRequest: ids,
          useCustomers: APIResponse,
          filters: {
            installation_has_rtu: 1,
          },
        });

        if (isArrayValid(APIInstallationsResponse)) {
          setCustomers(orderBy(APIInstallationsResponse, "customer_id", "desc"));

          const possibleProducts = uniq(
            APIInstallationsResponse.flatMap((x) =>
              x.installations?.map((installation) => installation.product_code)
            )
          );

          hub.notify(EVENT_HOME_PAGE_PRODUCT_FILTER_RECEIVE, possibleProducts);
        }
      }else if(!APIResponse.length && authProvider.hasHighLevel()){
        const favoriteUserInstallations: UserFavoriteInstallations = await hub.request(
          FETCH_USER_FAVORITE_INSTALLATIONS
        );

        if (isArrayValid(favoriteUserInstallations?.installationsIds)) {
          const filtersFavorite = {
            return_ids: false,
            installation_ids: favoriteUserInstallations?.installationsIds.map((e) => {
              return parseInt(e);
            }),
            installation_has_rtu: 1,
            page_size: favoriteUserInstallations?.installationsIds?.length,
          } as AllInstallationsFilterType;
          const installationsFavorites: IInstallation[] = await hub.request(
            FILTER_ALL_INSTALLATIONS_NEW,
            filtersFavorite
          );
  
          const favoritesData = {
            customer_id: "0",
            customer_name: "Favoritos",
            installations: installationsFavorites?.map((x) => {
              return { ...x, favorite: true };
            }),
          };

          const possibleProductsFavorites = uniq(
            favoritesData.installations.flatMap((x) =>
              x.product_code)
            );

          hub.notify(EVENT_HOME_PAGE_PRODUCT_FAVORITE_FILTER_RECEIVE, possibleProductsFavorites);

          StorageCache.set("favorites", favoritesData);

          setFavorites(favoritesData);
          setTempFavorites(favoritesData);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Home → FETCH_CUSTOMERS → error", error);
      toastr.enqueueSnackbar(
        "Ops! Ocorreu um erro ao tentar obter os dados das instalações. Tente novamente mais tarde!",
        { variant: "error" }
      );
    }

    setLoading(false);
  });

  const doSearch = async (filters: AllInstallationsFilterType) => {
    hub.notify(EVENT_HOME_INSTALLATIONS_ALREADY_LOADED, true);
    setHasSearched(true);
    const customerPosition = customers.findIndex((e) => e.customer_id == filters.customer_id);
    let customer: CustomerModel | undefined | null =
      customerPosition >= 0 ? customers[customerPosition] : undefined;

    let filtered = [];
    const favoritesAux = StorageCache.get<CustomerModel>("favorites");
    if (filters.customer_id == "0" && favoritesAux) {
      customer = favoritesAux;
    }
    if (customer) {
      if (customer.customer_id == "0" || filters.order) {
        const installations = customer?.installations;
        const { installation_name_id } = filters;

        const auxTripStatus = filters.installation_trip_status as string[];
        const auxAlert = filters.installation_alert as string[];

        const installationTripStatus =
          auxTripStatus?.length && auxTripStatus[0] !== "all" ? auxTripStatus : null;
        const installationProduct =
          filters?.installation_product?.length && filters?.installation_product[0] !== "all"
            ? filters.installation_product
            : null;
        const installationUf =
          filters?.installation_uf?.length && filters?.installation_uf[0] !== "all"
            ? filters.installation_uf
            : null;
        const installationAlert = auxAlert?.length && auxAlert[0] !== "all" ? auxAlert : null;
        filtered =
          installations?.filter((x) => {
            return (
              x.has_rtu &&
              (!installationProduct ||
                (installationProduct &&
                  x.product_code &&
                  installationProduct.includes(x.product_code))) &&
              (!installationAlert ||
                (installationAlert &&
                  x.installation_level_status &&
                  installationAlert.includes(x.installation_level_status))) &&
              (!installationUf || (installationUf && x.uf && installationUf.includes(x.uf))) &&
              (!installationTripStatus ||
                (installationTripStatus &&
                  x.trip_status &&
                  installationTripStatus.includes(x.trip_status))) &&
              (!installation_name_id ||
                (installation_name_id &&
                  includes(customer?.customer_name.toLocaleLowerCase(), installation_name_id)) ||
                includes(x.product_code?.toLocaleLowerCase(), installation_name_id) ||
                includes(x.installation_id.toLocaleLowerCase(), installation_name_id) ||
                includes(x.name?.toLocaleLowerCase(), installation_name_id) ||
                x.tanks
                  ?.map((x) => x.tank_id.toLocaleLowerCase())
                  .some((x) => includes(x, installation_name_id)))
            );
          }) || [];
        customer.installations = filtered;
        setFavorites(customer);
      } else {
        const possibleIdsOnCache =
          radixGroups
            .find((e) => e.id == filters.customer_id)
            ?.installationList.map((x) => x.installationId) ?? [];

        const auxFilters = {
          ...filters,
          installation_ids: possibleIdsOnCache,
          page_size: possibleIdsOnCache.length,
          installation_has_rtu: 1,
        };

        customer.installations = await hub.request(FILTER_ALL_INSTALLATIONS_NEW, auxFilters);
        setCustomers(
          orderBy(
            [...customers.filter((e) => e.customer_id != customer?.customer_id), customer],
            "customer_id",
            "desc"
          )
        );
      }
    }
    hub.notify(EVENT_HOME_INSTALLATIONS_ALREADY_LOADED);
  };

  useHubXSubscribe(EVENT_LANDING_PAGE_FILTER, !isLoading ? doSearch : () => {});

  async function handleExpand(idx: any) {
    setIdOpen([...idOpen, ...(idOpen?.filter((idOpen) => idOpen === idx).length > 0 ? [] : [idx])]);
    try {
      // verificar qual instalacoes do grupo estao fora das instalações ja pesquisadas
      const idsToVerify = groups
        .filter((group) => group.customer_id === customers[idx].customer_id)[0]
        ?.installationIds?.filter((installation) =>
          installationIdx.every((inst) => inst.installation_id !== installation)
        )
        .map((result) => {
          return { installation_id: result };
        });

      if (isArrayValid(idsToVerify)) {
        const APIInstallationsResponse: CustomerModel[] = await hub.request(FETCH_GROUPS, {
          idsToRequest: idsToVerify,
          useCustomers: groups,
          filters: {
            installation_has_rtu: 1,
          },
          resultToAppend: customers,
        });
        setInstallationIds([...installationIdx, ...idsToVerify]);
        if (isArrayValid(APIInstallationsResponse)) {
          setCustomers(orderBy(APIInstallationsResponse, "customer_id", "desc"));

          const possibleProducts = uniq(
            APIInstallationsResponse.flatMap((x) =>
              x.installations?.map((installation) => installation.product_code)
            )
          );
          hub.notify(EVENT_HOME_PAGE_PRODUCT_FILTER_RECEIVE, possibleProducts);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Home → FETCH_CUSTOMERS → error", error);
      toastr.enqueueSnackbar(
        "Ops! Ocorreu um erro ao tentar obter os dados das instalações. Tente novamente mais tarde!",
        { variant: "error" }
      );
    }
  }

  async function handleExpandAll() {
    try {
      setModalConfirmOpen(false);
      const idsToVerify = allInstallationIdx.filter((installation) =>
        installationIdx.every((inst) => inst.installation_id !== installation.installation_id)
      );

      if (isArrayValid(idsToVerify)) {
        setLoading(true);

        const APIInstallationsResponse: CustomerModel[] = await hub.request(FETCH_GROUPS, {
          idsToRequest: idsToVerify,
          useCustomers: groups,
          resultToAppend: customers,
          filters: {
            installation_has_rtu: 1,
          },
        });
        setInstallationIds(allInstallationIdx);
        if (isArrayValid(APIInstallationsResponse)) {
          setCustomers(orderBy(APIInstallationsResponse, "customer_id", "desc"));

          const possibleProducts = uniq(
            APIInstallationsResponse.flatMap((x) =>
              x.installations?.map((installation) => installation.product_code)
            )
          );
          hub.notify(EVENT_HOME_PAGE_PRODUCT_FILTER_RECEIVE, possibleProducts);
        }
      }

      const ids = [];
      for (let i = 0; i < customers.length; i++) {
        ids[i] = i;
      }
      setIdOpen(ids);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Home → FETCH_CUSTOMERS → error", error);
      toastr.enqueueSnackbar(
        "Ops! Ocorreu um erro ao tentar obter os dados das instalações. Tente novamente mais tarde!",
        { variant: "error" }
      );
    }
    setLoading(false);
  }

  function handleChange(nextView: HomePageViewType) {
    setView(nextView);
  }

  function handleClose(idx: any) {
    setIdOpen(idOpen?.filter((idOpen) => idOpen !== idx));
  }

  useHubXSubscribe(EVENT_HOMEPAGE_CHANGE_FILTER, handleChange);

  React.useLayoutEffect(() => {
    // only non rtu installations redirect
    const onlyNonRtuInstallations =
      isArrayValid(customers) &&
      customers
        .filter((x) => isArrayValid(x.installations))
        .every((x) => {
          return x.installations?.every((installation) => !installation.has_rtu);
        });

    if (
      !hasSearched &&
      onlyNonRtuInstallations &&
      !authProvider.hasHighLevel() &&
      !authProvider.isFreeUser
    ) {
      const redirectURL = homeAppLinks?.getFirstOrDefaultInstallationDetailRoute(
        "send_level",
        PERMISSION_ACCESS_INFORM_LEVEL
      );
      if (redirectURL) {
        history.replace(redirectURL);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeAppLinks, customers]);

  return (
    <Box mt={3}>
      {favorites && (authProvider.hasHighLevel() || authProvider.isFreeUser) && (
        <HomeGroupAccordion
          onLandingPage
          key={favorites.customer_id}
          startOpen
          favoriteGroup
          favoritesTooltip
          radixGroup={radixGroups.find((x) => x.id === favorites.customer_id)}
          customer={favorites}
          selectedView={view}
        />
      )}

      {!isLoading &&
        customers.map((customer, idx) => {
          return (
            <HomeGroupAccordion
              onLandingPage
              key={customer.customer_id}
              startOpen={
                !favorites &&
                !authProvider.hasHighLevel() &&
                idOpen?.filter((idOpen) => idOpen === idx).length > 0
              }
              customer={customer}
              radixGroup={radixGroups.find((x) => x.id == customer.customer_id)}
              selectedView={view}
              onExpand={() => handleExpand(idx)}
              onClose={() => handleClose(idx)}
              onExpandAll={() => handleExpandAll()}
            />
          );
        })}

      {isLoading &&
        emptyInstallations.map((_, idx) => (
          <Skeleton height={75} key={`installation_group_skeleton_${idx}`} />
        ))}

      <Dialog open={modalConfirmOpen}>
        <DialogTitle>
          Para pesquisar ou filtrar será necessário expandir todos os grupos de instalação. Deseja
          expandir?
        </DialogTitle>
        <DialogActions>
          <Button className={classes.buttonSecondary} onClick={() => setModalConfirmOpen(false)}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={() => handleExpandAll()}>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Home;
